import { useEffect, useState } from 'react';
import { TreeGame } from './components/TreeGame';
import { Profile } from './components/Profile';
import { DailyRewards } from './components/DailyRewards';
import { LeaderBoard } from './components/LeaderBoard';
import { NextRewardTimer } from './components/NextRewardTimer';
import { GameActions } from './components/GameActions';
import { Seasons } from './components/Seasons';
import { useNavigate } from 'react-router-dom';
import { RandomBonusModal } from './components/RandomBonusModal';
import Loader from 'src/pages/Education/components/Loader';
import { PageWrapper } from '../../ui/common';
import { useUserContext } from '../../contexts/UserContext';
import { bonusGameApi } from 'src/api/bonus-game';

interface GamePageProps {
  randomBonusModalVisible: boolean;
  setRandomBonusModalVisible: (val: boolean) => void;
}

export const GamePage = ({
  randomBonusModalVisible,
  setRandomBonusModalVisible,
}: GamePageProps) => {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(0);
  const [seasonBalance, setSeasonsBalance] = useState(0);
  const [endNumber, setEndNumber] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const { gameStat, setGameStat } = useUserContext();
  const [coinsLeft, setCoinsLeft] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const getStatRes = (await bonusGameApi.getStat()).result;

        console.log('getStatRes', !getStatRes?.welcomeBonusClaimed);

        if (!getStatRes?.welcomeBonusClaimed && +getStatRes?.rating) {
          navigate('/bonus-game/season-info');
        } else if (!getStatRes?.welcomeBonusClaimed) {
          navigate('/bonus-game/welcome');
        } else {
          setSeasonsBalance(Number(getStatRes.seasonRating));
          setBalance(Number(getStatRes?.rating));
          setEndNumber(Number(getStatRes?.rating));
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [endNumber]);

  useEffect(() => {
    (async () => {
      console.log('render', 'yes');

      const getStatRes = (await bonusGameApi.getStat()).result;

      setCoinsLeft(getStatRes.coinsLeft);
    })();
  }, []);

  if (isLoading || !gameStat || !coinsLeft) return <Loader small />;

  return (
    <PageWrapper style={{ paddingTop: '0' }}>
      <Profile balance={balance} />
      <Seasons seasonRating={seasonBalance} />
      <TreeGame setEndNumber={setEndNumber} coinsLeft={coinsLeft} />
      <NextRewardTimer endNumber={endNumber} />
      <DailyRewards daysInARow={gameStat.daysInARow} />
      <GameActions />
      <LeaderBoard />

      {randomBonusModalVisible && (
        <RandomBonusModal
          extraRewardAmount={gameStat.extraRewardAmount}
          setEndNumber={setEndNumber}
          closeModal={() => setRandomBonusModalVisible(false)}
        />
      )}
    </PageWrapper>
  );
};
